/**
 * Returns the page type from the dataLayer.
 */

export default () => {
    const data = window?.dataLayer?.[0] ?? {};
    return data.page_type ?? "";
}